const UploadToken = require('../entities/upload-token');

const fields = [];

function parse(json) {
  return new UploadToken(json.token, json.uploadUrl);
}

class UploadsRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  create(imageType
  /*: string*/
  , mimeType
  /*: string*/
  , width
  /*: number*/
  , height
  /*: number*/
  , size
  /*: number*/
  )
  /*: Promise<UploadToken>*/
  {
    const params = {
      imageType,
      mimeType,
      width,
      height,
      size
    };
    const req = new this.client.Request(`/media/upload/token`, params, fields);
    req.parse = parse;
    return this.client.get(req);
  }

  publish(uploadToken
  /*: UploadToken*/
  , focalPoint
  /*: { x: number, y: number }*/
  , keywords
  /*: [string]*/
  , filename
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const params = {
      token: uploadToken.token,
      focalPoint: focalPoint && [focalPoint.x, focalPoint.y],
      keywords,
      filename
    };
    const req = new this.client.Request('/media/upload/publish', params, []);
    return this.client.post(req);
  }

}

module.exports = UploadsRepo;